/**
 * Make an object with the components of a modal container... Rough and dirty, with some helpers...
 *
 * @return {{
 * 	$actions: HTMLDivElement, $content: HTMLDivElement, $dialog: HTMLDialogElement, $title: HTMLHeadingElement, $description: HTMLParagraphElement,
 * 	    close: function, open: function, remove: function, setTitle: function, setDescription: function, setContent: function, setActions: function,
 * 	    setBusy: function, removeOnClose: function
 * 	}}}
 */
export function makeModal() {
	const $dialog = document.createElement('dialog');
	$dialog.classList.add('ams-cpd-modal');
	$dialog.setAttribute('role', 'dialog');
	$dialog.setAttribute('aria-modal', 'true');
	$dialog.setAttribute('aria-labelledby', 'ams-cpd-modal-title');
	$dialog.setAttribute('aria-describedby', 'ams-cpd-modal-description');

	const $title = document.createElement('h1');
	$title.id = 'ams-cpd-modal-title';
	$title.classList.add('ams-cpd-modal__title');
	$dialog.appendChild($title);

	const $description = document.createElement('p');
	$description.id = 'ams-cpd-modal-description';
	$description.classList.add('ams-cpd-modal__description');
	$dialog.appendChild($description);

	const $content = document.createElement('div');
	$content.classList.add('ams-cpd-modal__content');

	$dialog.appendChild($content);

	const $actions = document.createElement('div');
	$actions.classList.add('ams-cpd-modal__actions');
	$dialog.appendChild($actions);

	document.querySelector('body').appendChild($dialog);

	let removeOnClose = true;

	// When the dialog is closed, maybe remove.
	$dialog.addEventListener('close', () => {
		if (removeOnClose) {
			$dialog.remove();
		}
	});

	return {
		$dialog, $title, $description, $content, $actions,
		/**
		 * Close the dialog.
		 */
		close() {
			$dialog.close();
		},
		/**
		 * Open the dialog.
		 */
		open() {
			$dialog.showModal();
		},
		/**
		 * Remove the dialog.
		 */
		remove() {
			$dialog.remove();
		},
		/**
		 * Set the title.
		 * @param {string} title
		 */
		setTitle(title) {
			$title.innerText = title;
		},
		/**
		 * Set the description.
		 * @param {string} description
		 */
		setDescription(description) {
			$description.innerText = description;
		},
		/**
		 * Set the content.
		 * @param {string|HTMLElement} content
		 */
		setContent(content) {
			$content.innerHTML = '';

			// If it's a string, set the innerHTML, otherwise add the child.
			if (typeof content === 'string') {
				$content.innerHTML = content;
				return;
			}

			$content.appendChild(content);
		},
		/**
		 * Set the actions.
		 * @param {string|HTMLElement} content
		 */
		setActions(actions) {
			$actions.innerHTML = '';

			// If it's a string, set the innerHTML, otherwise add the child.
			if (typeof actions === 'string') {
				$actions.innerHTML = actions;
				return;
			}

			$content.appendChild(actions);
		},
		/**
		 * Set the busy state.
		 * @param {bool} busy
		 */
		setBusy(busy) {
			if (busy) {
				$dialog.classList.add('busy');
				return;
			}

			$dialog.classList.remove('busy');
		},
		/**
		 * Remove the dialog on close?
		 * @param {bool} remove
		 */
		removeOnClose(remove) {
			removeOnClose = remove;
		}
	};
}
